import { render, staticRenderFns } from "./LogisticTraceabilitySamples.vue?vue&type=template&id=ff2a56c8&scoped=true"
import script from "./LogisticTraceabilitySamples.vue?vue&type=script&lang=js"
export * from "./LogisticTraceabilitySamples.vue?vue&type=script&lang=js"
import style0 from "./LogisticTraceabilitySamples.vue?vue&type=style&index=0&id=ff2a56c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2a56c8",
  null
  
)

export default component.exports